module.exports = __webpack_public_path__ + "img/circle-ring.fafcffb6.svg";